import React from 'react';
import { Delete, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Listing } from 'components/shared/TableListing';
import { Box, Button, IconButton, Stack, Tooltip } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { InterestInputField, InputField, CheckboxField } from 'components/form';

import { DealSheetFormValues } from './types';

export const TaxesSection = () => {
  const { control } = useFormContext<DealSheetFormValues>();
  const { fields, append, remove, move } = useFieldArray({ control, name: 'taxes' });

  return (
    <Listing
      tableData={fields}
      columns={[
        {
          renderKey: 'name',
          header: 'Tax Name',
          renderCell: ({ rowIndex }) => (
            <InputField
              control={control}
              label="Tax Name"
              name={`taxes.${rowIndex}.name`}
              inputProps={{ variant: 'outlined' }}
            />
          ),
        },
        {
          renderKey: 'amount',
          header: 'Tax Rate (%)',
          renderCell: ({ rowIndex }) => (
            <InterestInputField
              label="Rate"
              control={control}
              name={`taxes.${rowIndex}.amount`}
              textFieldProps={{ variant: 'outlined' }}
            />
          ),
        },
        {
          renderKey: 'name',
          header: 'Description',
          renderCell: ({ rowIndex }) => (
            <InputField
              control={control}
              label="Description"
              name={`taxes.${rowIndex}.description`}
              inputProps={{ variant: 'outlined', multiline: true, minRows: 3 }}
            />
          ),
        },
        {
          renderKey: 'isTaxable',
          header: 'Taxable',
          renderCell: ({ rowIndex }) => (
            <CheckboxField label="Taxable" control={control} name={`taxes.${rowIndex}.isTaxable`} />
          ),
        },
        {
          renderKey: 'name',
          header: 'Action',
          renderCell: ({ rowIndex }) => (
            <Stack direction="row" gap="0.5rem" alignItems="center">
              <Tooltip title="Move row down">
                <IconButton
                  size="small"
                  color="primary"
                  className="icon-btn-bordered"
                  disabled={rowIndex + 1 > fields.length - 1}
                  onClick={() => move(rowIndex, rowIndex + 1)}
                >
                  <KeyboardArrowDown />
                </IconButton>
              </Tooltip>

              <Tooltip title="Move row up">
                <IconButton
                  size="small"
                  color="primary"
                  className="icon-btn-bordered"
                  disabled={!rowIndex}
                  onClick={() => move(rowIndex, rowIndex - 1)}
                >
                  <KeyboardArrowUp />
                </IconButton>
              </Tooltip>

              <IconButton className="icon-btn-bordered" size="small" color="error" onClick={() => remove(rowIndex)}>
                <Delete />
              </IconButton>
            </Stack>
          ),
        },
      ]}
      actionPanelBottom={() => (
        <Box>
          <Button
            size="small"
            onClick={() => {
              append({
                name: '',
                amount: 0,
                type: 'TAX',
                description: '',
                isTaxable: true,
                amountType: 'percent',
                isEquipmentLvl: false,
              });
            }}
          >
            Add row
          </Button>
        </Box>
      )}
    />
  );
};
